<div class="paytm">
    <paytm-checkout></paytm-checkout>
</div>
